import type { Device } from "./types";

/**
 * QUAL nome o dispositivo mostra, e onde cada um vale.
 *
 * Um dispositivo carrega DOIS nomes, e eles servem a pessoas diferentes:
 *
 *   `mqttId`        identidade de REDE  — `ghm-80456b76ad44`, derivada do MAC.
 *                   Imutável: a ACL do broker prende o tópico ao usuário, e
 *                   usuário e `mqttId` são o mesmo valor. É o que se usa para
 *                   diagnosticar, conferir credencial e falar com o suporte.
 *
 *   `nomeFantasia`  identidade OPERACIONAL — "Extrusora 2". É como quem opera
 *                   a fábrica chama a máquina, e é o que precisa aparecer no
 *                   painel principal e na barra lateral, onde a pergunta é
 *                   "como está a extrusora", não "qual o MAC dela".
 *
 * A regra de precedência mora AQUI, e não espalhada em `??` pela interface,
 * porque ela tem uma sutileza: nome fantasia ausente e nome fantasia vazio são
 * a mesma coisa — ninguém nomeou —, e nesse caso a tela cai no `mqttId` em vez
 * de mostrar um rótulo em branco. Um card sem título é pior que um card com
 * nome técnico.
 */
export function nomeDeExibicao(device: Pick<Device, "mqttId" | "nomeFantasia">): string {
  const fantasia = device.nomeFantasia?.trim();
  return fantasia ? fantasia : device.mqttId;
}

/**
 * `true` quando a tela está mostrando o nome técnico por falta de um
 * operacional. Serve para a interface convidar a nomear ("dê um nome a este
 * dispositivo") sem precisar repetir a regra de precedência.
 */
export function estaSemNomeOperacional(
  device: Pick<Device, "nomeFantasia">,
): boolean {
  return !device.nomeFantasia?.trim();
}
